import React from 'react';

interface SkillsMarqueeProps {
  rows: string[][];
  speed?: number; // seconds per loop
}

/**
 * Infinite horizontally-scrolling skill chips. Alternating rows move in
 * opposite directions; hovering a row pauses it. Edges fade out via mask.
 */
const SkillsMarquee: React.FC<SkillsMarqueeProps> = ({ rows, speed = 30 }) => {
  return (
    <div className="space-y-4">
      {rows.map((row, rowIndex) => {
        const reverse = rowIndex % 2 === 1;
        return (
          <div key={rowIndex} className="marquee-mask overflow-hidden">
            <div
              className="flex w-max gap-3 marquee-track"
              style={{
                animationDuration: `${speed + rowIndex * 6}s`,
                animationDirection: reverse ? 'reverse' : 'normal',
              }}
            >
              {/* Duplicate content for a seamless loop */}
              {[...row, ...row].map((skill, i) => (
                <span
                  key={i}
                  className="whitespace-nowrap px-4 py-2 rounded-full text-sm text-gray-300 bg-white/5 border border-white/10 hover:border-primary-500/60 hover:text-white hover:bg-primary-500/10 transition-colors duration-200"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SkillsMarquee;
